import globalStore from '@/services/global.state';
import {
  getCurrentRechargeGift,
  type RechargeGiftScene,
  type RechargeGiftTier,
} from './recharge-gift.service';

const RECHARGE_GIFT_ROUTE_URI = 'route:RechargeGift';

export const isRechargeGiftRouteUri = (uri?: string | null) =>
  typeof uri === 'string' &&
  uri.trim().split('?')[0] === RECHARGE_GIFT_ROUTE_URI;

export const hasAvailableRechargeGiftTier = (gift?: RechargeGiftTier | null) =>
  gift?.show === true &&
  Number.isInteger(gift.currentTierNo) &&
  Number(gift.currentTierNo) > 0;

export const canShowRechargeGiftRouteEntry = async (
  scene: RechargeGiftScene,
) => {
  if (!globalStore.token) {
    return false;
  }
  const gift = await getCurrentRechargeGift(scene).catch(() => null);
  return hasAvailableRechargeGiftTier(gift);
};

export const filterRechargeGiftRouteEntries = async <T>(
  items: T[],
  getUri: (item: T) => string | null | undefined,
  scene: RechargeGiftScene,
) => {
  if (!items.some(item => isRechargeGiftRouteUri(getUri(item)))) {
    return items;
  }
  const canShow = await canShowRechargeGiftRouteEntry(scene);
  return canShow
    ? items
    : items.filter(item => !isRechargeGiftRouteUri(getUri(item)));
};
